export default {
  title: "Diabete Quebec",
  subtitle: "Subtitle",
  collecte: {
    listeobjectifs: "Goals",
    rechercher: "Search for a participant",
    retourAuxObjectifs: "Back to participants list",
    contribuez: "Contribute",
    commentaireTitre: "Write a message of encouragement (optional)",
    commentaireLabel: "Message",
    commentaireAnonymeLabel: "I want my message to remain anonymous",
    montantDonMasqueLabel: "I want the amount of my donation to remain hidden",
    anonyme: "Anonymous",
    participants: "Last contributions",
    aucunMessage: "No messages. Be the first !",
    voirTousLesMessages: "See all messages",
    voirLesDerniersMessages: ({ named }) => `See lasts ${named("n")} messages`,
    de: " from ",
  },
  objectifCard: {
    faireundon: "Make a donation",
    premierparticipant: "Be the first",
    participant: "participant",
    participants: "participants",
  },
  infosPersonnelles: {
    courriel: "E-mail",
    prenom: "First name",
    nom: "Last name",
    civilite: "Gender",
    anneeNaissance: "Year of birth",
  },
  adresse: {
    adresse: "Address",
    ville: "City",
    codePostal: "Postal code",
    province: "Province",
    telephone: "Phone number",
    telephoneAuTravail: "Work phone number",
  },
  dedicace: {
    prenom: "First name",
    nom: "Name",
    adresse: "Family address",
    ville: "City",
    codePostal: "Postal code",
    province: "Province",
    famille: "Family",
    consentementHonoriam:
      "I consent to having my information shared with the honoree",
    consentementMemoriam:
      "I consent to having my information shared with the family of the deceased",
  },
  formulaireDon: {
    donEnLigne: "Online donation",
    donInMemoriam: "In Memoriam donation",
    donInHonoriam: "In Honoriam donation",
    memoireDe: "In memory of...",
    occasionDe: "On the occasion of...",
    contribution: "Contribution",
    unique: "One-time",
    mensuel: "Monthly",
    detailPrelevement:
      "* Monthly donation: payment on the 1st day of the month",
    autre: "Other",
    montant: "Amount",
    source: "I heard about Diabetes Québec through",
    donateur: "Donor",
    donCorporatif: "Corporate donation",
    societe: "Society",
    adresse: "Address",
    boutonPaiement: "Pay now",
    numeroFondation: "Business Number : 13321 4601 RR0001",
    remerciementTitre: "Thank you!",
    remerciementParagraphe:
      "<p>Your donation has been processed. An e-mail has been sent to you with your income-tax receipt.</p>",
    remerciementParagrapheMensuel:
      "<p>We acknowledge receipt of your registration for the Créateurs d’espoir monthly giving program and sincerely thank you for your support.</p><p>Your donation will be withdrawn from your credit card on the 1st of each month. Please note that you will only receive one charitable tax receipt at the end of the year.</p><p>You can end this agreement at any time by contacting our Members and Donors Services at 514-259-3422, ext. 227 / 1-800-361-3504, ext. 227.</p>",
    retourObjectif: "Back to the participant's page",
    retourEvenement: "Back to the event's page",
  },
  formulaireAuth: {
    sousTitre:
      "If you are a member, indicate your number as well as your postal code in order to identify yourself.",
    numero: "Number",
    codePostal: "Postal code",
    seConnecter: "Log in",
    seDeconnecter: "Log out",
    connexion: "Login",
    unauthorizedMessage:
      "Your username and postal code are not recognized. Make sure you enter a 6-digit number.",
  },
  locales: {
    fr: "Français",
    en: "English",
  },
  rules: {
    champObligatoire: "This field is required",
    codePostalNonValide: "Invalid postal code",
    telephoneNonValide: "Invalid phone number",
    courrielNonValide: "Invalid email",
    messageTropLong: "Maximum length of message is 300 caracters.",
    erreurCodePromo: "Non-existent or incorrect promotional code",
  },
  boutique: {
    titre: "Online Store",
    retourALaBoutique: "Back to store",
    viderLePanier: "Empty cart",
    contenuDuPanier: "Cart",
    payer: "Pay now",
    finaliser: "Finalize the order",
    retourALaListeDesProduits: "Back to products list",
    dejaMembre:
      "If you are a member, use the LOGIN button on top right of the page.",
    ajouterAuPanier: "Add to cart",
    tableauProduits: {
      titre: "Title",
      categorie: "Category",
      langue: "Language",
      prix: "Price",
    },
    voirPlus: "See more...",
    panier: {
      ajouter: "Add one",
      retirer: "Remove",
      fraisPoste: "Postal fees",
      fraisSup: "Additional fees",
      tps: "TPS",
      tvq: "TVQ",
      total: "Total",
      panierVide: "Empty cart",
    },
    passerALaCaisse: "Checkout",
    adresseLivraison: "Shipping address",
    rechercherUnProduit: "Search for a product...",
    toutesLesCategories: "All",
    toutesLesLangues: "All",
    produits: "Products",
    affichage: "View",
    modePaiement: "Payment method",
    messageError: "An error occurred during payment, please try again.",
    messageSucces: "Your payment has been accepted. Thanks.",
  },
  chargement: "Loading...",
  formulaireAdhesion: {
    professionnelDeLaSante: {
      titre: "On-line Membership - Health Care Professional",
      lien: "Health Care Professional",
      agreementSharing:
        "Do you agree that Diabetes Québec shares your personal details with its training entity Universi-D?",
      profession: "Profession",
      license: "Professionnal order number",
    },
    personneVivantAvecLeDiabete: {
      titre: "On-line membership - Person affected by diabetes",
      lien: "Person affected by diabetes",
    },
    informationsPersonnelles: "Personnal informations",
    adresse: "Personnal address",
    desireFaireUnDon:
      "I wish to make a donation in addition to paying for my annual membership",
    typeAdhesion:
      "I wish to become a member of Diabetes Québec and receive a free copy of DIA·LOGUE.",
    versionPleinSoleil: "I prefer to receive DIA·LOGUE in version:",
    boutonPaiement: "Confirm membership",
    remerciementTitre: "Welcome to Diabetes Québec!",
    remerciementParagraphe:
      "<p>Your subscription request has been received.</p>",
    codePromo: "Apply promotional code",
    codePromoLabel: "Promotional code",
    boutonCheckCodePromo: "Apply",
    source: "I heard about Diabetes Québec through",
  },
  transactionRealisee: "<p>Transaction successfully completed.</p>",
  paysafe: {
    buttonLabel: "Confirm",
    locale: "en_US",
    companyName: "Diabète Québec",
  },
  revuesPleinSoleil: {
    searchLabel: "Search / Filter",
    titreRevue: "Title",
    dateParution: "Publication date",
    urlModeFlip: "FlipBook viewing link",
    urlModePdf: "PDF viewing link",
  },
  erreur: {
    paiement: {
      titre: "An error occured during your payment.",
      description:
        "Please contact us for more information or to make your donation by phone.",
      telephone: "514-259-3422 ext. 227 / 1-800-361-3504  ext. 227",
    },
    collecte: {
      titre:
        "An error occured while loading this event or it is no longer available.",
      description: "Please contact us for more information.",
      telephone: "514-259-3422 ext. 227 / 1-800-361-3504  ext. 227",
    },
  },
  avertissements: {
    redirectionDepuisEspaceMembre:
      "<p>Please note that we are currently making changes to the Member Section. You have been redirected to a new page to proceed with your renewal, make a donation or access the store. Thank you for your understanding.</p><p>The Diabetes Québec Team</p>",
  },
}
